import React from 'react';
import Types from 'constants/types';
import Predicates from 'constants/predicates';

import DefaultModal from './body/DefaultModal';
import AttachmentModal from './body/AttachmentModal';
import ImageModal from './body/ImageModal';
import RelatedObjectModal from './body/RelatedObjectModal';
import StatementTextModal from './body/StatementTextModal';
import StatementCommentModal from './body/StatementCommentModal';

// Custom Modal Modals based on Resource type
// SPEC-37, SPEC-38, SPEC-39
export default function ModalBody({ resource }) {
  if (resource.addLink) {
    return <iframe 
      className='search-iframe'
      frameBorder='0'
      src={resource.searchUri} />;
  }

  // #84 - custom modal for statement texts
  if(resource.showStatementPresets) {
	return <StatementTextModal resource={resource} />;
  }
  
  // #99 - custom modal for statement comments
  if(resource.showStatementComment) {
	return <StatementCommentModal resource={resource} />;
  }

  switch(resource.classUri) {
  case Types.ARCHIVE.IMAGE:
    return <ImageModal resource={resource} />;

  case Types.ARCHIVE.DOCUMENT:
    return <AttachmentModal resource={resource} />;

  case Types.SPECTRUM.RELATED_OBJECT:
    return <RelatedObjectModal resource={resource} />;

  default: return <DefaultModal resource={resource} />;
  }
}

